var _defs, _g, _path, _path2, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup48312(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 307.46,
    height: 288.982,
    viewBox: "0 0 307.46 288.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.539,
    y1: -1.309,
    x2: 1.472,
    y2: 1.358,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.878,
    y1: 0.993,
    x2: 0.375,
    y2: 0.079,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 82.151,
    y1: -21.203,
    x2: 82.35,
    y2: -19.417,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.392,
    y1: -1.238,
    x2: 0.832,
    y2: -0.076,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -4.811,
    y1: 0.284,
    x2: -4.293,
    y2: 2.674,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 64.096,
    y1: -57.155,
    x2: 64.251,
    y2: -52.442,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 33.862,
    y1: 0.171,
    x2: 34.484,
    y2: 1.621,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.063,
    y1: -0.535,
    x2: 1.162,
    y2: 2.302,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.931,
    y1: 8.329,
    x2: 2.019,
    y2: 8.226,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -4.959,
    y1: -4.015,
    x2: 4.85,
    y2: 3.922,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1.046,
    y1: 25.801,
    x2: 5.007,
    y2: 25.47,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1.555,
    y1: 0.873,
    x2: 0.333,
    y2: 0.383,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 430.665,
    y1: 0.954,
    x2: 432.826,
    y2: -0.303,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 49.713,
    y1: 0.128,
    x2: 49.96,
    y2: -20.758,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 39.474,
    y1: 4.039,
    x2: 39.671,
    y2: -0.315,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 36.253,
    y1: 41.104,
    x2: 35.514,
    y2: 43.541,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.122,
    y1: 0.927,
    x2: 0.749,
    y2: 0.247,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48312",
    "data-name": "Group 48312",
    transform: "translate(-1983.986 -1135.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48307",
    "data-name": "Group 48307",
    transform: "translate(2055.626 1135.265)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48304",
    "data-name": "Group 48304",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38939",
    "data-name": "Path 38939",
    d: "M2225.618,1155.024s-8.925-10.7,3.208-17.3,31.2.639,33.611,14.665,14.465,5.7,19.726,2.63,19.944-7.233,23.67,8.766c1.476,6.338-.393,14.434,2.357,20.331,3.788,8.123,16.116,6.023,22.847,9.127,8.75,4.036,13.321,11.844,8.768,20.951-7.014,14.027-20.821,22.941-13.369,35.141s-22.575,39.6-32.876,14.172-26.3-21.119-39.231-22.724-19.506-12.786-16-24.181-1.1-18.189-5.918-23.01S2211.372,1167.956,2225.618,1155.024Z",
    transform: "translate(-2122.231 -1135.265)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48303",
    "data-name": "Group 48303",
    transform: "translate(0 142.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38940",
    "data-name": "Path 38940",
    d: "M2192.606,1352.87a57.024,57.024,0,0,0-20.679,8.826,5.458,5.458,0,0,0-2.409,5.215c1.312,10.381,6.7,43.982,24.469,76.8a8.262,8.262,0,0,1,.793,5.67l-3.087,14.366-5.725,5.368h14.746l9.818-26.57-4.2-1.328a7.945,7.945,0,0,1-5.548-7.437l-.492-28.5c.421-12.7-7.786-21.46-7.786-21.46l23.55-1.145Z",
    transform: "translate(-2107.998 -1339.565)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38941",
    "data-name": "Path 38941",
    d: "M2184.4,1506.437c-1.344,1.758,14.454,4.077,22.435.233,0,0,11.063-19.249,11.063-29.16,0,0-.878-2.021-7.374-1.562,0,0-3.715,22.792-7.637,25.345s-10.975.258-10.975.258S2186.383,1503.843,2184.4,1506.437Z",
    transform: "translate(-2112.189 -1374.295)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38942",
    "data-name": "Path 38942",
    d: "M2191.56,1385.674c-.125-.217-25.355-3.033-25.355-3.033a58.31,58.31,0,0,1-1.755,18.231c-2.581,10.56-39.624,56.313-39.624,56.313l3.885,12.313a62.475,62.475,0,0,1-35.447,2.132l24.071-14.445s22.528-76.771,36.327-90.467l25.29-8.75Z",
    transform: "translate(-2086.48 -1341.004)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38943",
    "data-name": "Path 38943",
    d: "M2272,1334.33s14.536,21.621,15.729,31.483-3.982,13.87-19.234,14.531-55.969.651-55.969.651l-34.752-29.7s25.325-9.037,31.91-11.592S2272,1334.33,2272,1334.33Z",
    transform: "translate(-2110.342 -1334.33)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38944",
    "data-name": "Path 38944",
    d: "M2124.573,1507.6s4.182,4.05,1.357,8.557c0,0-33.126,5.872-42.119,3.207,0,0,1.867-4.262,11.994-9.114l-.747.573a1.21,1.21,0,0,0,.8,2.17C2102.531,1512.611,2116.342,1511.388,2124.573,1507.6Z",
    transform: "translate(-2083.811 -1383.25)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38945",
    "data-name": "Path 38945",
    d: "M2242.48,1299.508s-16.927-16.119-25.26-26.795a22.65,22.65,0,0,1-3.835-20.386c3.8-12.817,10.565-26.091,11.181-28.157.945-3.167,19.925-3.035,19.925-3.035s37.349,24.24,52.024,65.3l-16.48,5.131s-9.752-16.36-19.387-26.762c0,0,16.673,22.025,17.26,31.042Z",
    transform: "translate(-2120.129 -1159.51)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38946",
    "data-name": "Path 38946",
    d: "M2226.137,1199.7c.2.658,5.152,17.081,5.54,17.422s10.864.9,15.8-2.466l-8.366-17.513Z",
    transform: "translate(-2123.996 -1152.735)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38947",
    "data-name": "Path 38947",
    d: "M2230.428,1152.429s-8.944,3.776-15.024,16.7-1.54,18.89,4.164,19.709,14.235.695,23.258-7.654S2242.054,1147.953,2230.428,1152.429Z",
    transform: "translate(-2120.149 -1139.96)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38948",
    "data-name": "Path 38948",
    d: "M2240.077,1169.775s6.747-18.907-10.016-19.131l-3.945,2.757s-6.15-10.483,3.945-15.487,25.158-.549,29.454,13.052,1.781,22.382-5.366,28.89-10.092-.871-10.092-.871,3.892-6.086,2.307-9.343-5.239.674-5.239.674Z",
    transform: "translate(-2123.466 -1135.451)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38949",
    "data-name": "Path 38949",
    d: "M2243.81,1184.635s3.412-9.74,7.962-5.861-3.7,9-6.928,10.654Z",
    transform: "translate(-2128.985 -1147.292)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38950",
    "data-name": "Path 38950",
    d: "M2206.245,1326.4l12.436-11.987,17.205,7.268s17.125,2.653,26.927,0l9.8-2.653,22.15-6.9,3.479,9.832a5.919,5.919,0,0,1-2.162,6.8,39.122,39.122,0,0,1-5.594,3.485c-2.917,1.276-71.9-.884-71.9-.884Z",
    transform: "translate(-2118.379 -1185.2)",
    fill: "url(#linear-gradient-12)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48305",
    "data-name": "Group 48305",
    transform: "translate(137.856 22.791)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38951",
    "data-name": "Path 38951",
    d: "M2316.258,1179.7l-.587-.063c.511-4.7-.271-7.836-2.39-9.581-4.2-3.46-12.913-.753-20.6,1.634-3.893,1.209-7.572,2.352-10.148,2.49a5.908,5.908,0,0,1-4.695-1.557c-2.089-2.087-1.938-5.461-1.931-5.6l.589.031c0,.032-.141,3.26,1.762,5.157a5.349,5.349,0,0,0,4.243,1.382c2.5-.133,6.147-1.265,10-2.463,7.829-2.432,16.7-5.189,21.15-1.526C2315.942,1171.485,2316.792,1174.789,2316.258,1179.7Z",
    transform: "translate(-2275.902 -1167.023)",
    fill: "#bdd0fb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48306",
    "data-name": "Group 48306",
    transform: "translate(193.618 60.029)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38952",
    "data-name": "Path 38952",
    d: "M2356.5,1265.183c-1.385-5.693,2.354-10.5,6.684-16.07,3.116-4.008,6.648-8.551,8.54-14a8.011,8.011,0,0,0-.583-7.1c-4.031-6.575-17.408-8.49-17.543-8.509l.081-.585c.561.078,13.79,1.974,17.965,8.785a8.575,8.575,0,0,1,.637,7.607c-1.923,5.544-5.487,10.128-8.632,14.172-4.235,5.447-7.894,10.152-6.576,15.568Z",
    transform: "translate(-2353.602 -1218.911)",
    fill: "#bdd0fb"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48308",
    "data-name": "Group 48308",
    transform: "translate(2153.661 1322.796)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148111",
    "data-name": "Rectangle 148111",
    width: 6.551,
    height: 70.847,
    transform: "translate(31.662 15.875)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38953",
    "data-name": "Path 38953",
    d: "M2286.5,1517.639h-57.379a4.264,4.264,0,0,1,4.264-4.264h48.85a4.265,4.265,0,0,1,4.265,4.264Z",
    transform: "translate(-2222.873 -1429.552)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148112",
    "data-name": "Rectangle 148112",
    width: 72.143,
    height: 20.461,
    rx: 9.817,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-15)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48309",
    "data-name": "Group 48309",
    transform: "translate(2048.589 1216.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38954",
    "data-name": "Path 38954",
    d: "M2242.109,1337.314c-.054,0-.11,0-.166,0l-72.144-.078a3.229,3.229,0,0,1,.006-6.458l72.145.078a3.229,3.229,0,0,1,.158,6.455Z",
    transform: "translate(-2100.141 -1271.811)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38955",
    "data-name": "Path 38955",
    d: "M2078.808,1248.611h60.082a11.453,11.453,0,0,1,10.357,6.567l27.775,58.9h-74.666a6.959,6.959,0,0,1-6.473-4.4l-21.539-54.5A4.8,4.8,0,0,1,2078.808,1248.611Z",
    transform: "translate(-2074.006 -1248.611)",
    fill: "url(#linear-gradient-17)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48311",
    "data-name": "Group 48311",
    transform: "translate(1983.986 1281.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38956",
    "data-name": "Path 38956",
    d: "M2291.392,1342.249a2.664,2.664,0,0,0-.627-2.306,3.057,3.057,0,0,0-2.3-1.016H1987.413a3.487,3.487,0,0,0-2.886,1.482,3.038,3.038,0,0,0-.225,3.077l3.262,6.619a4.6,4.6,0,0,0,4.147,2.486H2286.4a3.409,3.409,0,0,0,3.4-2.626Z",
    transform: "translate(-1983.986 -1338.928)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48310",
    "data-name": "Group 48310",
    transform: "translate(17.659 5.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38957",
    "data-name": "Path 38957",
    d: "M2011.234,1483.963a2.6,2.6,0,0,1-1.043-.221,2.728,2.728,0,0,1-1.383-3.552l55.409-131.79a2.621,2.621,0,0,1,3.471-1.414,2.727,2.727,0,0,1,1.383,3.551l-55.409,131.79A2.643,2.643,0,0,1,2011.234,1483.963Z",
    transform: "translate(-2008.593 -1346.765)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38958",
    "data-name": "Path 38958",
    d: "M2076.412,1483.962a2.642,2.642,0,0,1-2.428-1.636l-55.409-131.79a2.726,2.726,0,0,1,1.383-3.551,2.62,2.62,0,0,1,3.47,1.415l55.409,131.79a2.727,2.727,0,0,1-1.382,3.552A2.592,2.592,0,0,1,2076.412,1483.962Z",
    transform: "translate(-2011.35 -1346.764)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38959",
    "data-name": "Path 38959",
    d: "M2315.271,1483.963a2.6,2.6,0,0,1-1.043-.221,2.728,2.728,0,0,1-1.383-3.552l55.409-131.79a2.621,2.621,0,0,1,3.471-1.414,2.727,2.727,0,0,1,1.383,3.551l-55.409,131.79A2.643,2.643,0,0,1,2315.271,1483.963Z",
    transform: "translate(-2094.435 -1346.765)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38960",
    "data-name": "Path 38960",
    d: "M2380.449,1483.962a2.642,2.642,0,0,1-2.428-1.636l-55.409-131.79a2.728,2.728,0,0,1,1.383-3.551,2.62,2.62,0,0,1,3.471,1.415l55.409,131.79a2.728,2.728,0,0,1-1.383,3.552A2.591,2.591,0,0,1,2380.449,1483.962Z",
    transform: "translate(-2097.192 -1346.764)",
    fill: "url(#linear-gradient-18)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48312);
export default __webpack_public_path__ + "static/media/Group 48312.02c8b05ef6e3cab38183308622c91376.svg";
export { ForwardRef as ReactComponent };